import { ImageCropContextProvider, ImageCropProviderProps } from './ImageCropContext';
import { ImageCropInner, ImageCropInnerProps } from './ImageCropInner';

export interface ImageCropProps extends ImageCropProviderProps, ImageCropInnerProps {}

export const ImageCrop = ({
    className,
    src,
    strings,
    inputProps,
    aspect,
    circularCrop,
    validateCallback,
    uploadCallbackAsync,
    resetCallbackAsync,
    processingErrorCallback,
}: ImageCropProps) => {
    return (
        <ImageCropContextProvider
            uploadCallbackAsync={uploadCallbackAsync}
            resetCallbackAsync={resetCallbackAsync}
            processingErrorCallback={processingErrorCallback}
        >
            <ImageCropInner
                className={className}
                src={src}
                strings={strings}
                inputProps={inputProps}
                aspect={aspect}
                circularCrop={circularCrop}
                validateCallback={validateCallback}
            />
        </ImageCropContextProvider>
    );
};
